import { createFileRoute } from '@tanstack/react-router';
import { AuthLayout } from '@/features/auth/components/auth-layout/AuthLayout';
import { ConfirmEmailPage } from '@/features/auth/pages/confirm-email-page/ConfirmEmailPage';

const RouteComponent = () => {
  const { uidb64, token } = Route.useParams();
  return (
    <AuthLayout>
      <ConfirmEmailPage uidb64={uidb64} token={token} />
    </AuthLayout>
  );
};

export const Route = createFileRoute('/verify/$uidb64/$token')({
  component: RouteComponent,
});
